import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate amount
  const amount = properties.amount;
  if (amount === undefined || amount === null) {
    errors.push({ key: 'amount', message: 'Wait amount is required' });
  } else if (typeof amount !== 'number') {
    errors.push({ key: 'amount', message: 'Wait amount must be a number' });
  } else if (amount <= 0) {
    errors.push({ key: 'amount', message: 'Wait amount must be greater than 0' });
  }

  // Validate unit
  const unit = properties.unit;
  const validUnits = ['milliseconds', 'seconds', 'minutes', 'hours'];
  if (!unit) {
    errors.push({ key: 'unit', message: 'Time unit is required' });
  } else if (!validUnits.includes(unit)) {
    errors.push({ key: 'unit', message: `Unit must be one of: ${validUnits.join(', ')}` });
  }

  // Validate max wait time (1 hour)
  if (amount && unit) {
    const multipliers: Record<string, number> = {
      'milliseconds': 1,
      'seconds': 1000,
      'minutes': 60000,
      'hours': 3600000
    };
    
    const waitMs = amount * (multipliers[unit] || 1000);
    if (waitMs > 3600000) {
      errors.push({ key: 'amount', message: 'Wait time cannot exceed 1 hour' });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
